import { render, staticRenderFns } from "./win-lead-modal.vue?vue&type=template&id=2548b834&"
import script from "./win-lead-modal.vue?vue&type=script&lang=js&"
export * from "./win-lead-modal.vue?vue&type=script&lang=js&"
import style0 from "./win-lead-modal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/win-lead-modal.vue
// module id = 1429
// module chunks = 0